<template>
  <section id="resolution_container">
    <div class="columns">
      <div class="column is-4">
        <CompanySelector v-model="company"/>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-table :data="tableData" :selected.sync="selected" focusable>
          <b-table-column field="company" label="Empresa" v-slot="props">
            {{ props.row.company.name }}
          </b-table-column>
          <b-table-column field="prefix" label="Prefijo" v-slot="props">
            {{ props.row.prefix }}
          </b-table-column>
          <b-table-column field="company" label="Fecha Inicial" v-slot="props">
            {{ props.row.initialDate }}
          </b-table-column>
          <b-table-column field="company" label="Fecha Final" v-slot="props">
            {{ props.row.finalDate }}
          </b-table-column>
          <b-table-column field="date" label="Valor Inicial" v-slot="props">
            {{ props.row.initialValue }}
          </b-table-column>
          <b-table-column field="type" label="Valor Final" v-slot="props">
            {{ props.row.finalValue }}
          </b-table-column>
          <b-table-column field="type" label="Valor Actual" v-slot="props">
            {{ props.row.currentValue }}
          </b-table-column>
          <b-table-column field="type" label="Opciones" v-slot="props">
            <b-field>
              <b-button
                  type="is-info"
                  title="Edit"
                  @click="editRow(props.row)"
                  icon-right="pencil"/>
            </b-field>
          </b-table-column>
          <template #bottom-left></template>
          <template #empty>
            <div class="has-text-centered">Sin registros</div>
          </template>
        </b-table>
      </div>
    </div>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
  </section>
</template>

<script>
import {ROUTES} from "@/global/api_routes";
import CompanySelector from "@/components/Shared/CompanySelector";

export default {
  name: "ResolutionList",
  components: {CompanySelector},
  data() {
    return {
      company: null,
      isLoading: false,
      tableData: [],
      selected: null
    };
  },
  watch: {
    company() {
      this.listResolutions();
    }
  }, methods: {
    listResolutions() {
      const company = this.company;
      this.isLoading = true;
      this.$http.get(ROUTES.DASHBOARD.RESOLUTION.GET_RESOLUTION, {
        params: {
          companyId: company,
        },
      }).then(({data}) => {
        if (data.code > 0) {
          this.tableData = data.info;
          this.selected = null;
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    editRow(data) {
      this.$router.push({name: "Resolución", params: {resolutionId: data.code}});
    }
  }
}
</script>

<style scoped>

</style>